import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { Goal } from "@curai/js-fhir-tools";

interface GetGoalsResponse {
  goals: Goal[];
}

export const useGetGoals = (patientId?: string) => {
  return useApi<GetGoalsResponse, Goal[]>({
    queryOptions: {
      enabled: !!patientId,
      queryKey: QueryKeys.Patient.MedicalRecords.Goals.DEFAULT(patientId),
      queryFn: async () => {
        const response = await axiosInstance.get("/charting/goal", {
          params: {
            patientId,
          },
        });
        return response?.data;
      },
      select: (data: GetGoalsResponse) => {
        return data?.goals?.map((goal) => new Goal(goal));
      },
    },
  });
};
